import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import StandardTableVue from '../../../components/table/StandardTable.vue';
import FooterToolBar from '../../../components/tool/FooterToolBar.vue';
import selectGroupVue from '@/components/commonAdd/selectGroupDyx.vue';
import { saveErp, getErpDetail } from '@/services/customer/erpGrouped';
export default {
  components: {
    StandardTableVue: StandardTableVue,
    FooterToolBar: FooterToolBar,
    selectGroupVue: selectGroupVue
  },
  i18n: require("./i18n-dyx"),
  data: function data() {
    var _this = this;
    var columns = [{
      dataIndex: 'erpCustomerCode',
      title: this.$t('account.dyxNumber')
    }, {
      title: this.$t('account.dyxName'),
      dataIndex: 'erpCustomerName',
      scopedSlots: {
        customRender: 'erpCustomerName'
      }
    }, {
      title: this.$t('account.status'),
      dataIndex: 'erpCustomerStatus',
      scopedSlots: {
        customRender: 'erpCustomerStatus'
      }
    }, {
      title: this.$t('account.ddz'),
      dataIndex: 'sellerName'
    }, {
      title: this.$t('account.yetai'),
      dataIndex: 'busFormatName'
    }, {
      title: this.$t('emailAction'),
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      form: {
        groupName: ''
      },
      visible: false,
      saveData: [],
      loadingSave: false,
      columns: columns,
      loadingTable: false,
      pagination: {
        pageSizeOptions: ['10', '20', '30'],
        total: 0,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('account.total')).concat(total);
        },
        pageSize: 10,
        current: 1,
        showSizeChanger: true
      },
      total: 0,
      sarchValue: '',
      addList: [],
      alreadySelect: [],
      editID: null
    };
  },
  computed: {
    data: function data() {
      var _this2 = this;
      if (this.sarchValue == '') {
        return this.saveData;
      } else {
        return this.saveData.filter(function (item) {
          return item.erpCustomerCode.indexOf(_this2.sarchValue) !== -1 || item.erpCustomerName.indexOf(_this2.sarchValue) !== -1;
        });
      }
    }
  },
  mounted: function mounted() {
    this.editID = this.$route.query['id'];
    if (this.editID) {
      this.initData();
    }
  },
  methods: {
    initData: function initData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this3.loadingTable = true;
              _context.p = 1;
              _context.n = 2;
              return getErpDetail(_this3.editID);
            case 2:
              res = _context.v;
              if (res.data.code == 200) {
                _this3.form.groupName = res.data.data.groupName;
                _this3.saveData = res.data.data.erpCustomerList;
                _this3.pagination.total = res.data.data.erpCustomerList.length;
                _this3.alreadySelect = _this3.saveData.map(function (item) {
                  return item.erpCustomerId;
                });
              }
            case 3:
              _context.p = 3;
              _this3.loadingTable = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 3, 4]]);
      }))();
    },
    addEdit: function addEdit(row) {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.$refs.selectModal.visible = true;
        // this.total = this.saveData.length
      });
    },
    deleteGroup: function deleteGroup() {},
    confirmDelete: function confirmDelete(e) {
      this.saveData = this.saveData.filter(function (item) {
        return item.erpCustomerCode !== e.erpCustomerCode;
      });
      this.alreadySelect = this.saveData.map(function (item) {
        return item.erpCustomerId;
      });
      this.pagination.total = this.saveData.length;
    },
    cancelDelete: function cancelDelete() {},
    changePage: function changePage(e) {
      console.log(e);
    },
    showSizeChange: function showSizeChange(e) {
      console.log(e);
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this5.$refs.formModel.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
                  var erpCustomerIds, params, res;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        if (!valid) {
                          _context2.n = 4;
                          break;
                        }
                        _this5.loadingSave = true;
                        erpCustomerIds = _this5.saveData.map(function (item) {
                          return item.erpCustomerId;
                        });
                        if (_this5.editID) {
                          params = {
                            groupId: _this5.editID,
                            groupName: _this5.form.groupName,
                            erpCustomerIds: erpCustomerIds
                          };
                        } else {
                          params = {
                            groupName: _this5.form.groupName,
                            erpCustomerIds: erpCustomerIds
                          };
                        }
                        _context2.p = 1;
                        _context2.n = 2;
                        return saveErp(params);
                      case 2:
                        res = _context2.v;
                        if (res.data.code == 200) {
                          _this5.editID = res.data.data;
                          _this5.$message.success(_this5.$t('public.saveSuccessfully'));
                          // this.initData()
                        }
                      case 3:
                        _context2.p = 3;
                        _this5.loadingSave = false;
                        return _context2.f(3);
                      case 4:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[1,, 3, 4]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getTotal: function getTotal(total, data) {
      this.total = total;
      this.pagination.total = total;
      this.addList = data;
    },
    goProduct: function goProduct(id) {
      var routeData = this.$router.resolve({
        path: '/customermanager/editcustomer2',
        query: {
          erpCustomerId: id
        }
      });
      window.open(routeData.href, '_blank');
      // this.$router.push({path:'productDetail',query:{id: id}})
    },
    confirmProduct: function confirmProduct(data) {
      console.log(data, 'data......');
      this.saveData = data;
      this.alreadySelect = data.map(function (item) {
        return item.erpCustomerId;
      });
      this.pagination.total = data.length;
    }
  }
};